// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"86c59e37","513":"2fea7a1c","703":"447302bf","787":"76813b38"}[chunkId] + ".chunk.js";
};